/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-contact-info-slider .mx-20px{margin-left:20px;margin-right:20px}app-contact-info-slider .modal-backdrop{background-color:rgba(0,0,0,.3)}app-contact-info-slider .close-btn{width:48px;height:48px;margin-top:8px;margin-right:8px;border:none;background-color:#fff}"];
export { styles as styles };
